// extracted by mini-css-extract-plugin
export var error_hint = "feedback_form-module--error_hint--cppVa";
export var error_icon = "feedback_form-module--error_icon--sl2qa";
export var file_input = "feedback_form-module--file_input--BRff+";
export var hint_wrapper = "feedback_form-module--hint_wrapper--todpf";